import { memoize } from "@plansoft-configuration-renderer/utils";
export const createNumberFormatter = memoize((locale) => new Intl.NumberFormat(locale, {
    maximumFractionDigits: 17,
}));
//# sourceMappingURL=createNumberFormatter.js.map